// Business-level constants used across the marketing site.
//
// BUSINESS_START_DATE is the anchor for the auto-updating "X+ years in
// business" badge on the landing page. It must never change — increment
// happens automatically each 1-Jan.

export const BUSINESS_START_DATE = new Date("2023-01-01T00:00:00Z");

/**
 * Whole-year count between BUSINESS_START_DATE and today.
 * "3+ years" from 2026-01-01 onwards, "4+ years" from 2027-01-01 onwards, etc.
 * Returns an integer >= 0.
 */
export function yearsInBusiness(now = new Date()) {
  const start = BUSINESS_START_DATE;
  let years = now.getUTCFullYear() - start.getUTCFullYear();
  const beforeAnniversary =
    now.getUTCMonth() < start.getUTCMonth() ||
    (now.getUTCMonth() === start.getUTCMonth() && now.getUTCDate() < start.getUTCDate());
  if (beforeAnniversary) years -= 1;
  return Math.max(0, years);
}
